import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IModelsParams, IModelsResponse, IModelsState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchListModels = createAsyncThunk(
  'listModels/fetchListModels',
  async ({ query }: IModelsParams, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.getModels(query)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IModelsState = {
  isLoading: false,
  response: null,
  error: null
}

const listModelsSlice = createSlice({
  name: 'models/list',
  initialState,
  reducers: {
    resetListModels: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchListModels.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchListModels.fulfilled, (state, action: PayloadAction<IModelsResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchListModels.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default listModelsSlice.reducer
export const { resetListModels } = listModelsSlice.actions
